import { createContext } from 'react';

export const TableContext = createContext<{
  isOverflowing: boolean;
}>({ isOverflowing: false });
